import { useTheme } from "@/lib/theme";
import { Sun, Moon } from "lucide-react";
import { track } from "@/lib/analytics";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const onToggle = () => {
    toggle();
    track("theme_toggle", { to: isDark ? "light" : "dark" });
  };
  return (
    <button
      data-testid="theme-toggle"
      onClick={onToggle}
      aria-label="Toggle theme"
      className={`relative w-9 h-9 rounded-full border border-[var(--border-dim)] flex items-center justify-center hover:border-[var(--vermilion)] transition-colors ${className}`}
    >
      {isDark ? (
        <Sun className="w-3.5 h-3.5 text-[var(--lime)]" />
      ) : (
        <Moon className="w-3.5 h-3.5 text-[var(--vermilion)]" />
      )}
    </button>
  );
}
